<template>
  <transition name="fade">
    <div
      v-if="showMobileHelp && isTouchDevice"
      class="mobile-help"
    >
      <h3>
        Tutorial
      </h3>
      <img
        v-if="mobileHelpStep === 1"
        src="../assets/highlight_mesh.svg"
        alt=""
      >
      <p v-if="mobileHelpStep === 1">
        Nutzen Sie die Controller am unteren Bildschirmrand um die Sonde zu bewegen und zu rotieren.
      </p>
      <img
        v-if="mobileHelpStep === 2"
        src="../assets/highlight_slice.svg"
        alt=""
      >
      <p v-if="mobileHelpStep === 2">
        Hier sehen Sie das Schnittbild.
      </p>
      <img
        v-if="mobileHelpStep === 3"
        src="../assets/highlight_solution.svg"
        alt=""
      >
      <p v-if="mobileHelpStep === 3">
        Klicken Sie auf eine der Lösungen um zu lösen.
      </p>
      <button
        v-if="mobileHelpStep <= 2"
        class="btn btn-secondary next"
        @click="mobileHelpStep++"
      >
        Weiter
      </button>
      <button
        v-if="mobileHelpStep >= 2"
        class="btn btn-secondary previous"
        @click="mobileHelpStep--"
      >
        Zurück
      </button>
      <button
        v-if="mobileHelpStep === 3"
        class="btn btn-secondary done"
        @click="$emit('showMobileHelp', false), mobileHelpStep = 1"
      >
        Verstanden
      </button>
      <a
        class="exit"
        @click="$emit('showMobileHelp', false), mobileHelpStep = 1"
      >
        Überspringen
      </a>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'MobileTutorial',
  props: {
    isTouchDevice: {
      type: Boolean,
      default: undefined
    },
    showMobileHelp: {
      type: Boolean,
      default: undefined
    }
  },
  data: function () {
    return {
      mobileHelpStep: 1
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style.scss';
.mobile-help{
  padding: 15px;
  background-color: $cyan;
  position: fixed;
  z-index: 1060;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  color: $bg-light;
  overflow-y: scroll;
  .next, .done{
    width: calc(50% - 5px);
    float: right;
  }
  .previous{
    width: calc(50% - 5px);
    float: left;
  }
  .exit{
    position: absolute;
    bottom: 0;
    right: 15px;
    left: 15px;
    margin-bottom: 15px;
    text-align: right;
  }
}
</style>
